export default __webpack_public_path__ + "static/media/3855.bae96ccd.png";